import * as React from 'react'
import styled from 'styled-components'
import {Link} from 'react-router-dom'
import {StartBtn} from 'src/components/atoms/input/buttons'

interface Props {
  next?: string
  text: string
  addOn?(): void
  disabled?: boolean
  preventLink?: boolean
  hideOnMobile?: boolean
}

export default class Navigation extends React.Component<Props, any> {
  isSafari = () => {
    const userAgent = navigator.userAgent.toLowerCase()
    return (
      userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1
    )
  }

  onClickLink = (e) => {
    const { preventLink } = this.props
    if (preventLink) e.preventDefault()
  }

  render() {
    const { addOn, disabled, next, text, hideOnMobile } = this.props
    return (
      <>
        <Container isSafari={this.isSafari()} hide={hideOnMobile && disabled}>
          <Link id='next' to={next + location.search || ''} onClick={(e) => this.onClickLink(e)}>
            <StartBtn
              style={{ height: 'unset', width: 'unset', minWidth: '12em' }}
              onClick={addOn}
              disabled={disabled}>
              {text}
            </StartBtn>
          </Link>
        </Container>
      </>
    )
  }
}

const Container = styled.div`
  grid-area: navigation;
  align-self: center;
  text-align: center;

  @media (max-height: 768px), (max-width: 768px) {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    margin-bottom: 15px;
    transition: transform 0.4s ease;
    z-index: 10;
    ${(props) =>
      props.hide &&
      `
      transform: translateY(160px);
      transition: none;
    `}
  }
`



// WEBPACK FOOTER //
// ./src/components/atoms/wizard/Navigation.tsx